import { useGlobalState } from './stateProvider/StateProvider';

export const userRoles = {
    admin: 'Administrator',
    technicalInterfaceMaven: 'T.I.M.',
    accountConfiguration: 'Account Configuration',
    editCustomers: 'Edit Customers',
    editDashboard: 'Edit Dashboard',
    editProducts: 'Edit Products',
    fulfillment: 'Fulfillment',
    issueRewash: 'Issue Rewash',
    viewAuditReports: 'View Audit Reports',
    viewCustomers: 'View Customers',
    viewDashboard: 'View Dashboard',
    viewFinancialReports: 'View Financial Reports',
    viewProducts: 'View Products',
    viewUsageReports: 'View Usage Reports',
    editLoyaltyAccount: 'Edit Loyalty Account',
    setupLoyaltyAccount: 'Setup Loyalty Account',
    manageAppUsers: 'Manage App Users',
    notifications: 'Notifications',
    betaTester: 'Beta Tester'
}

//state safe/no-hooks version of bool check for use when needed in loops/map or similar
export const UserIsAuthorized = (active_user, roles) => {
    if (!(roles instanceof Array)) roles = [roles]
    roles = roles.filter(e => e);   
    return roles.length === 0 ? true : (active_user.roles.some(e => roles.includes(e))) ? true : false;
}

export const IsAuthorized = (roles) => {
    const { state: { active_user, } } = useGlobalState();
    if (!(roles instanceof Array)) roles = [roles]
    roles = roles.filter(e => e);   
    return roles.length === 0 ? true : (active_user.roles.some(e => roles.includes(e))) ? true : false;
}

const RoleProtected = ({ roles, children, ...props }) => {
    const { state: { active_user, } } = useGlobalState();
    if (!(roles instanceof Array)) roles = [roles]
    roles = roles.filter(e => e); 
    return roles.length === 0 ? children : (active_user.roles.some(e => roles.includes(e))) ? children : null;
}

export default RoleProtected;